import { Box } from '@mui/material'
import UsersQuotaStats from './UsersQuotaStats'
import FeaturesQuotaStats from './FeaturesQuotaStats'

function QuotaStats() {
  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <UsersQuotaStats />
      <FeaturesQuotaStats />
    </Box>
  )
}

export default QuotaStats
